import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

export const MuiPopoverTheme = (mode: PaletteMode): Components<Theme>['MuiPopover'] => {
  const { componentTokens } = themePalette(mode);

  return {
    defaultProps: {
      BackdropProps: {
        style: {
          backgroundColor: 'transparent',
        },
      },
    },
    styleOverrides: {
      paper: {
        // Remove the default Paper overlay gradient
        '--Paper-overlay': 'none',
        backgroundColor: componentTokens.selectMenuItems.color.item.background.containerBase,
        boxShadow: 'none',
        backgroundImage: 'none',
        // Override the specific MUI Paper overlay
        '&::before': {
          backgroundImage: 'none',
          display: 'none',
        },
      },
    },
  };
};
